export default __webpack_public_path__ + "static/media/logo.abf70e24.svg";